import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("main", {
    staticClass: "swiper-form"
  }, [_c("a-form", {
    attrs: {
      form: _vm.form
    }
  }, [_c("Card", {
    attrs: {
      title: _vm.$t("form.setting")
    }
  }, [_c("CardItem", {
    attrs: {
      title: _vm.$t("form.location")
    }
  }, [_c("a-select", {
    attrs: {
      mode: "multiple",
      placeholder: _vm.$t("form.placeSelectLocation")
    },
    model: {
      value: _vm.value.location,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "location", $$v);
      },
      expression: "value.location"
    }
  }, _vm._l(_vm.locationClient, function (item, i) {
    return _c("a-select-option", {
      key: i,
      attrs: {
        value: item.value
      }
    }, [_vm._v(" " + _vm._s(item.label) + " ")]);
  }), 1)], 1), _c("CardItem", {
    attrs: {
      title: _vm.$t("form.pcBgColor")
    }
  }, [_c("ColorPicker", {
    model: {
      value: _vm.value.pcBgColor,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "pcBgColor", $$v);
      },
      expression: "value.pcBgColor"
    }
  })], 1)], 1), _c("Card", {
    attrs: {
      title: _vm.$t("form.contentSetting")
    }
  }, [_c("CardItem", {
    attrs: {
      title: _vm.$t("form.autoPlay")
    }
  }, [_c("a-switch", {
    attrs: {
      "checked-children": _vm.$t("form.open"),
      "un-checked-children": _vm.$t("form.close")
    },
    model: {
      value: _vm.value.autoPlay,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "autoPlay", $$v);
      },
      expression: "value.autoPlay"
    }
  })], 1), _c("CardItem", {
    attrs: {
      title: _vm.$t("form.interval"),
      layout: "vertical"
    }
  }, [_c("InputBar", {
    attrs: {
      min: 3,
      max: 9,
      suffix: "s"
    },
    model: {
      value: _vm.value.autoPlayTime,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "autoPlayTime", $$v);
      },
      expression: "value.autoPlayTime"
    }
  })], 1), _c("CardItem", {
    attrs: {
      title: _vm.$t("form.vertical")
    }
  }, [_c("a-switch", {
    attrs: {
      "checked-children": _vm.$t("form.open"),
      "un-checked-children": _vm.$t("form.close")
    },
    model: {
      value: _vm.value.vertical,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "vertical", $$v);
      },
      expression: "value.vertical"
    }
  })], 1), _c("CardItem", {
    attrs: {
      title: _vm.$t("form.content"),
      layout: "vertical"
    }
  }, [_c("CardItem", {
    attrs: {
      layout: "vertical"
    }
  }, [_c("a-alert", {
    attrs: {
      message: _vm.$t("com.dragSort"),
      "show-icon": ""
    }
  })], 1), _c("ImgList", {
    model: {
      value: _vm.value.pathLink,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "pathLink", $$v);
      },
      expression: "value.pathLink"
    }
  })], 1), _c("CardItem", {
    class: {
      "location-disabled": !_vm.value.location.includes(1)
    },
    attrs: {
      title: _vm.$t("form.pcSwiperHeight"),
      layout: "vertical"
    }
  }, [_c("a-row", [_c("InputBarSelect", {
    attrs: {
      min: 100,
      max: 600,
      options: _vm.pcHeight
    },
    model: {
      value: _vm.value.pcHeight,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "pcHeight", $$v);
      },
      expression: "value.pcHeight"
    }
  })], 1)], 1), _c("CardItem", {
    class: {
      "location-disabled": !_vm.value.location.includes(2)
    },
    attrs: {
      title: _vm.$t("form.mSwiperHeight"),
      layout: "vertical"
    }
  }, [_c("a-row", [_c("InputBarSelect", {
    attrs: {
      min: 10,
      max: 400,
      options: _vm.mHeight
    },
    model: {
      value: _vm.value.mHeight,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "mHeight", $$v);
      },
      expression: "value.mHeight"
    }
  })], 1)], 1)], 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };